import { Controller } from 'stimulus'

export default class extends Controller {
  static targets = ['form', 'datePicker']

  connect () {
    this.updateEstimatedShippingDate()
  }

  openDatePicker () {
    if (!this.hasDatePickerTarget) return

    this.datePickerTarget.showPicker()
  }

  updateEstimatedShippingDate () {
    if (!this.hasDatePickerTarget) return

    this.datePickerTarget.addEventListener('change', () => {
      this.submitForm()
    })
  }

  deliveryTypeChanged (_event) {
    this.submitForm()
  }

  submitForm () {
    if (typeof this.formTarget.requestSubmit === 'function') {
      this.formTarget.requestSubmit()
    } else {
      this.formTarget.submit()
    }
  }
}
